import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowDownRightIcon } from "lucide-react";
import { BracketButton } from "./BracketButton";
import { Overline } from "./Overline";
import { images } from "../data/content";
export function Hero() {
  const reduce = useReducedMotion();
  const rise = (delay: number) => ({
    initial: reduce ? false : {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease: [0.23, 1, 0.32, 1]
    }
  });
  return <section id="top" className="relative overflow-hidden" data-id="element-155" data-mp="xbfmhg6avp8a">
      <div className="bg-lines absolute inset-x-0 top-0 h-[560px] [mask-image:linear-gradient(to_bottom,black,transparent)]" aria-hidden="true" data-id="element-156" data-mp="sbb1pdyd08c9" />
      <div className="relative mx-auto max-w-[1400px] px-5 pt-16 text-center md:px-10 md:pt-24" data-id="element-157" data-mp="nbewjbdxeav4">
        <motion.div {...rise(0)} className="flex justify-center" data-id="element-158" data-mp="3d2bkbqsid1w2">
          <Overline data-id="element-159" data-mp="381xm10gpl6b8">Jérémy Couput · Recrutement SAFTI</Overline>
        </motion.div>
        <motion.h1 {...rise(0.05)} className="mx-auto mt-7 max-w-[1150px] text-[52px] font-semibold leading-[0.92] tracking-[-0.045em] text-ink sm:text-[76px] md:text-[104px] lg:text-[128px]" data-id="element-160" data-mp="3j8ix6zga0gup">
          Devenez <span className="font-serif font-normal italic tracking-[-0.02em] text-brand" data-id="element-161" data-mp="39b4gqzucrs2e">conseiller</span>
          <br data-id="element-162" data-mp="3e8egb8bghk3y" />
          immobilier avec SAFTI
        </motion.h1>
        <motion.p {...rise(0.1)} className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-ink-muted" data-id="element-163" data-mp="30iaziwvciilw">
          Lancez votre activité d'indépendant au sein de la Infiny Team : liberté d'organisation, formation complète et un
          accompagnement humain à chaque étape.
        </motion.p>
        <motion.div {...rise(0.15)} className="mt-10 flex flex-wrap items-center justify-center gap-4" data-id="element-164" data-mp="2viy4houbm588">
          <BracketButton href="#contact" data-id="element-165" data-mp="2hjf7ns6ymgb8">Rejoignez-nous !</BracketButton>
          <BracketButton href="#avantages" variant="light" data-id="element-166" data-mp="2hl9q8zurdwc5">
            Découvrir les avantages
          </BracketButton>
        </motion.div>
      </div>

      <div className="relative mx-auto mt-20 grid max-w-[1400px] items-end gap-10 px-5 md:px-10 lg:grid-cols-[260px_1fr_280px]" data-id="element-167" data-mp="s3349bcaykwh">
        <div className="flex items-center gap-5 lg:flex-col lg:items-start lg:pb-10" data-id="element-168" data-mp="na0ap37izbga">
          <img src={images.portraitRound} alt="Portrait de Jérémy Couput" className="h-28 w-28 shrink-0 rounded-full object-cover lg:h-40 lg:w-40" data-id="element-169" data-mp="icro8qfcgl98" />
          <div data-id="element-170" data-mp="1azkqxecanulv">
            <p className="text-[56px] font-semibold leading-none tracking-[-0.04em]" data-id="element-171" data-mp="1b04at0li8t2j">
              99<span className="text-brand" data-id="element-172" data-mp="162c95ev25sl5">%</span>
            </p>
            <p className="mt-2 max-w-[180px] text-[15px] leading-snug text-ink-muted" data-id="element-173" data-mp="111yagnfcjuzs">de commission reversée au conseiller, au plus haut du barème</p>
          </div>
        </div>

        <div className="relative" data-id="element-174" data-mp="3lsp33cogahdw">
          <img src={images.house} alt="Villa contemporaine aux murs blancs et toit de tuiles, entourée d'oliviers et de lavande" className="aspect-[16/10] w-full object-cover" data-id="element-175" data-mp="3ltqdrg1k11v3" />
          <span className="absolute bottom-0 left-0 bg-paper px-4 py-2 text-[12px] font-medium uppercase tracking-[0.2em] text-ink" data-id="element-176" data-mp="1xb5ped03cpfl">
            Indépendant · Partout en France
          </span>
        </div>

        <div className="lg:pb-10" data-id="element-177" data-mp="267wkam2wpy8l">
          <a href="#safti" className="mb-8 flex h-20 w-20 items-center justify-center rounded-full border border-ink/20 transition-colors duration-150 hover:border-brand hover:bg-brand hover:text-white" aria-label="Faire défiler vers la présentation" data-id="element-178" data-mp="2b196yqo0zuyp">
            <ArrowDownRightIcon className="h-6 w-6" data-id="element-179" data-mp="2ozz4g7erbwnl" />
          </a>
          <p className="text-[19px] leading-snug tracking-[-0.01em]" data-id="element-180" data-mp="2oynzi49ksiuw">
            Être conseiller SAFTI, c'est entreprendre <span className="text-ink-faint" data-id="element-181" data-mp="umhe6cmywlov">sans vitrine ni loyer d'agence,</span> et
            avec une équipe qui vous fait grandir.
          </p>
        </div>
      </div>
    </section>;
}